import { datadogRum } from '@datadog/browser-rum';
import { useIndxResults } from '@opendoor/tessellation';
import moment from 'moment';

import useReIndexWorkOrder from '../../../graphql/mutations/indextrious/useReIndexWorkOrder';

interface Props {
  id: string;
  startDate: string;
  progress: string;
}

const ShouldReIndex = (props: Props) => {
  const { id, startDate, progress } = props;

  const [reIndexWorkOrder] = useReIndexWorkOrder();
  const { refetch } = useIndxResults();

  const lastReindexAt = localStorage.getItem(id);
  const currDate = moment().format('YYYY-MM-DD');

  const reIndex = async () => {
    const startTimestamp = moment();

    await reIndexWorkOrder({ variables: { id } });
    localStorage.setItem(id, startTimestamp.format('YYYY-MM-DD'));
    refetch();

    datadogRum.addAction('reIndexWorkOrder', {
      id,
      timeTakenInMs: moment().diff(startTimestamp, 'milliseconds'),
    });
  };

  if (
    progress === 'WAITING_FOR_ALLOWED_START' &&
    moment().local().isSameOrAfter(startDate) &&
    (lastReindexAt === null || lastReindexAt !== currDate)
  ) {
    reIndex();
  }

  return null;
};

export default ShouldReIndex;
